import * as Yup from 'yup';

import { Warning } from '@const/translations';

const INN_REGEXP = /^(\d{10}|\d{12})$/;
const LENGTHS_INN = {
  MIN: 10,
  MAX: 10,
};

const REGEX_ORG_NAME = /^([\p{L}\p{N}\p{S}\p{P}\p{Z}]){4,2000}$/u;
const REGEX_DESC = /^([\p{L}\p{N}\p{S}\p{P}\p{Z}]){0,255}$/u;

const mandateSchema = Yup.object().shape({
  issuedDate: Yup.date().required(Warning.required),
  guid: Yup.string().required(Warning.required).uuid(Warning.guid),
  organizationName: Yup.string()
    .matches(REGEX_ORG_NAME, Warning.orgName)
    .required(Warning.required),
  organizationInn: Yup.string()
    .nullable()
    .matches(INN_REGEXP, Warning.inn)
    .max(LENGTHS_INN.MAX, Warning.inn)
    .min(LENGTHS_INN.MIN, Warning.inn)
    .required(Warning.required),
  boxOguid: Yup.string().required(Warning.required),
  validFrom: Yup.date().nullable().required(Warning.required),
  validTo: Yup.date().nullable().required(Warning.required),
  description: Yup.string().nullable().matches(REGEX_DESC, Warning.desc),
});

const mandatesObjectSchema = Yup.lazy((obj: Record<string, any>) =>
  Yup.object(
    Object.keys(obj || {}).reduce((acc, key) => {
      acc[key] = mandateSchema;
      return acc;
    }, {} as Record<string, Yup.ObjectSchema<any>>)
  )
);

export const powersValidationSchema = mandatesObjectSchema;
